
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import {
  updateStoreShoppingCart,
  PackageListDto,
  ShopGoodsInfoDto,
  addStoreShoppingCart,
  isGoodsValid
} from '@/api/industryMall'
import { Debounce } from '@/core/decorator'
import store from '@/store'
@Component({
  name: 'priceFun',
  components: {
    StepperTemp
  }
})
export default class priceFun extends Vue {
  @Prop({ default: () => ({}) }) data: PackageListDto
  @Prop({ default: () => ({}) }) goods: ShopGoodsInfoDto
  @Prop({ default: () => false }) showStep: boolean
  @Prop({ default: false }) showAnimation?: boolean // 是否展示动画
  @Prop({ default: () => {} }) readonly handleGoodsValid: () => void // 商品是否下架判断函数
  @Getter partnerCompanyId!: string

  get sellPrice() {
    // return (Number(this.data.marketPrice) / this.data.sellUnit).toFixed(2)
    return (Number(this.data.finalPrice) / this.data.sellUnit).toFixed(2)
  }

  get isActivity() {
    return (this.goods.isAddTag === 0 || this.goods.isAddTag === 1)
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    console.log('goods',this.data);
    
    const params = {
      shopId: this.goods.storeId,
      packageId: this.data.packageId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.handleGoodsValid()
            })
          return false
        }
      })
      .catch(() => {
        this.$dialog
          .alert({
            message: '商品过期不存在'
          })
          .then(() => {
            this.handleGoodsValid()
          })
        return false
      })
  }

  onShowStep(e: Event) {
    console.log('onShowStep', e)
    this.isGoodsValid().then((res) => {
      if (res) {
        if (e && this.showAnimation) {
          this.$shopCarAnimation.show(e)
        }
        this.data.orderQuantity = 1
        this.addStoreShoppingCart()
      }
    })
  }

  blur(value) {
    this.isGoodsValid().then((res) => {
      if (res) {
        this.updateBuyCar(value)
      }
    })
  }

  @Debounce(300) // 防抖
  plus(value, event) {
    this.isGoodsValid().then((res) => {
      if (res) {
        if (event && this.showAnimation) {
          // this.shopCarAnimation(event)
          this.$shopCarAnimation.show(event)
        }
        this.updateBuyCar(value)
      }
    })
  }
  @Debounce(300) // 防抖
  minus(value) {
    this.isGoodsValid().then((res) => {
      if (res) {
        this.updateBuyCar(value)
      }
    })
  }

  // 加入购物车
  addStoreShoppingCart() {
    const param = {
      partnerCompanyId: this.partnerCompanyId,
      storeId: this.goods.storeId,
      goodsId: this.goods.goodsId,
      packageId: this.data.packageId,
      orderQuantity: 1
    }
    addStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  // 更新购物车
  updateBuyCar(orderQuantity) {
    console.log('orderQuantity', orderQuantity)

    const param = {
      partnerCompanyId: this.partnerCompanyId,
      goodsId: this.goods.goodsId,
      packageId: this.data.packageId,
      storeId: this.goods.storeId,
      orderQuantity
    }
    updateStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  handleEmpty() {}
}
